import("@needle-tools/engine") /* async import of needle engine */;

import "./CompanyStyleModuleUI.js";

console.log("🚀 Needle Engine main.ts 启动");